import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import RowButton from "@/signomatic/components/row_button"
import Toolbox from "@/signomatic/components/toolbox"
import { type ToolboxStripItemProps } from "@/signomatic/components/toolbox_strip"
import { type State } from "@/signomatic/store/reducers"
import { CopyOutline } from "@/skylticons"

interface SidesToolboxStateProps {
  signType: string
  signState: SignState
  signs: SignType[]
}

type SidesToolboxProps = SidesToolboxStateProps & ToolboxStripItemProps

const SidesToolbox: React.FC<SidesToolboxProps> = ({ sign, signState }) => {
  const { t } = useTranslation()

  return (
    <Toolbox tKey="sides">
      <div className="side-switcher">
        <div>
          <label className="paragraph-xs bold mb-0 hidden xl:block">{t("toolbox.side")}</label>
        </div>
        <div className="sides" onClick={() => (signState.side === 0 ? sign.setSide(1) : sign.setSide(0))}>
          <div className={cn("side", "a", { active: signState.side === 0 })}>
            <div className="letter z-10">A</div>
          </div>
          <div className={cn("side", "b", { active: signState.side === 1 })}>
            <div className="letter z-10">B</div>
          </div>
        </div>

        <RowButton className="button button-primary full-width side-copy mb-0" onClick={() => sign.copySide()}>
          <CopyOutline />
          <span>{t("toolbox.copy_side")}</span>
        </RowButton>
      </div>
    </Toolbox>
  )
}

export default connect(({ signType, signState }: State) => ({
  signType,
  signState,
}))(SidesToolbox)
